import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Button,
    Text,
    Box
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ItemCount from './item-count'
import Sort from './sort'
import GridViewSelector from './grid-view-selector'

const FiltersHeader = ({
    refinements,
    handleFilterClick,
    sortingOptions,
    sortUrls,
    selectedSortingOption,
    productSearchResult,
    containerProps,
    gridView,
    setGridView,
    hideFiltersAndSort,
    showItemCount = false,
    hideSortAndGrid = false,
    styles
}) => {
    return (
        <Box {...containerProps}>
            <Flex justifyContent={hideFiltersAndSort && !showItemCount ? 'center' : 'space-between'} alignItems="center">
                {hideFiltersAndSort && showItemCount && (
                    <Flex minW={{base: 'auto', md: '200px'}}><ItemCount count={productSearchResult?.total} /></Flex>
                )}
                {!hideFiltersAndSort && (
                    <Flex align="center" minW={{base: 'auto', md: '200px'}}>
                        {Object.keys(refinements).map((key) => (
                            <Button
                                key={key}
                                variant="filter"
                                data-testid={`plp-button-${key.toLowerCase()}`}
                                onClick={() => handleFilterClick(refinements[key]?.[0]?.attributeId)}
                            >
                                <Text as="span" {...styles.filterSortLabel}>
                                    {key}
                                </Text>
                            </Button>
                        ))}
                        <ItemCount count={productSearchResult?.total} />
                    </Flex>
                )}
                {gridView !== undefined && setGridView && (
                    <Box display={{base: 'none', md: 'block'}}>
                        <GridViewSelector gridView={gridView} setGridView={setGridView} />
                    </Box>
                )}
                {gridView !== undefined && setGridView && (
                    <Box display={{base: 'block', md: 'none'}}>
                        <GridViewSelector gridView={gridView} setGridView={setGridView} />
                    </Box>
                )}
                {!hideFiltersAndSort && (
                    <Flex display={{base: 'none', md: 'flex'}} align="center" justifyContent="end" gap={2} minW={{base: 'auto', md: '200px'}}>
                        <Flex display={{base: 'none', md: 'flex'}} align="center">
                            <Sort
                                sortingOptions={sortingOptions}
                                sortUrls={sortUrls}
                                selectedSortingOption={selectedSortingOption}
                            />
                        </Flex>
                    </Flex>
                )}
                {hideFiltersAndSort && showItemCount && <Box display={{base: 'none', md: 'block'}} minW="200px" />}
            </Flex>
        </Box>
    )
}

FiltersHeader.propTypes = {
    handleFilterClick: PropTypes.func.isRequired,
    refinements: PropTypes.object.isRequired,
    sortingOptions: PropTypes.array,
    sortUrls: PropTypes.array.isRequired,
    selectedSortingOption: PropTypes.string,
    productSearchResult: PropTypes.object.isRequired,
    containerProps: PropTypes.object,
    gridView: PropTypes.string,
    setGridView: PropTypes.func,
    hideFiltersAndSort: PropTypes.bool,
    showItemCount: PropTypes.bool,
    hideSortAndGrid: PropTypes.bool,
    styles: PropTypes.object
}

export default FiltersHeader
